import React from 'react';
import Tabs from '@src/containers/VoiceLeaderboard/Header/Tabs';
import Title from './Title';
import { StyledHeaderContainer, StyledHeaderContent } from '../index.style';
import PeriodSwitcher from './PeriodSwitcher';

const Header = ({ eventShow, activeTab, handleChangeTab, showInfoEvent }) => (
  <StyledHeaderContainer>
    <StyledHeaderContent>
      <Title />
      {showInfoEvent && (
        <>
          <PeriodSwitcher
            endDate={eventShow?.endDate}
            startDate={eventShow?.startDate}
          />
          <Tabs activeTab={activeTab} handleChangeTab={handleChangeTab} />
        </>
      )}
    </StyledHeaderContent>
  </StyledHeaderContainer>
);

export default Header;
